"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBar = void 0;
const material_1 = require("@mui/material");
const react_1 = __importStar(require("react"));
const NavBarMenuSection_1 = require("./NavBarMenuSection");
const NavBarContentSection_1 = require("./NavBarContentSection");
const NavBarLeadingSection_1 = require("./NavBarLeadingSection");
const NavBarTrailingSection_1 = require("./NavBarTrailingSection");
function NavBar(props) {
    const theme = (0, material_1.useTheme)();
    return (react_1.default.createElement("nav", { style: {
            width: '100%',
            backgroundColor: theme.palette.primary.main,
        } },
        react_1.default.createElement("div", { className: "flex flex-row max-w-[75rem] py-[1.5rem] px-[1rem] md:!px-[2rem] gap-[1rem] items-center mx-auto" },
            react_1.default.Children.toArray(props.children)
                .filter(react_1.isValidElement)
                .filter(child => child.type === NavBarMenuSection_1.NavBarMenuSection),
            react_1.default.Children.toArray(props.children)
                .filter(react_1.isValidElement)
                .filter(child => child.type === NavBarLeadingSection_1.NavBarLeadingSection),
            react_1.default.createElement("div", { className: "flex-grow" }, react_1.default.Children.toArray(props.children)
                .filter(react_1.isValidElement)
                .filter(child => child.type === NavBarContentSection_1.NavBarContentSection)),
            react_1.default.Children.toArray(props.children)
                .filter(react_1.isValidElement)
                .filter(child => child.type === NavBarTrailingSection_1.NavBarTrailingSection))));
}
exports.NavBar = NavBar;
